module.exports = __webpack_public_path__ + "img/blog-1.df3d3fa2.jpg";